var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70725 3.12132C5.31673 2.7308 4.68356 2.7308 4.29304 3.12132L2.92567 4.48869C2.40917 5.00519 2.23877 5.71337 2.45198 6.30881C5.0011 13.4277 11.4099 17.9599 15.6674 19.5523C16.2321 19.7635 16.9241 19.5804 17.4243 19.0176L18.924 17.3305C19.2909 16.9177 19.2537 16.2856 18.841 15.9187L16.6572 13.9776C16.4014 13.7502 16.0472 13.6694 15.7181 13.7635L13.8243 14.3045C13.3042 14.4531 12.69 14.4811 12.0953 14.2493C9.67029 13.304 8.32523 11.2523 7.76912 9.9232C7.51664 9.31974 7.54718 8.69534 7.6956 8.17584L8.21533 6.35681C8.3151 6.00762 8.21771 5.63178 7.96091 5.37498L5.70725 3.12132ZM2.87882 1.70711C4.0504 0.535536 5.94989 0.535538 7.12146 1.70711L9.37512 3.96077C10.1455 4.73116 10.4377 5.85867 10.1384 6.90625L9.61865 8.72528C9.56187 8.924 9.57832 9.06563 9.61414 9.15125C10.0461 10.1836 11.0764 11.7055 12.8217 12.3859C12.923 12.4253 13.0767 12.4381 13.2749 12.3815L15.1687 11.8404C16.1558 11.5584 17.2186 11.8007 17.9859 12.4828L20.1697 14.4239C21.408 15.5246 21.5196 17.4208 20.4188 18.6592L18.9191 20.3464C17.9729 21.4108 16.4412 21.9771 14.9667 21.4256C10.3232 19.6887 3.36925 14.8031 0.569055 6.98304C0.0628603 5.5694 0.518999 4.06694 1.51146 3.07447L2.87882 1.70711Z",
    fill: "#0B30B2",
    stroke: "#fff",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCall);
export default __webpack_public_path__ + "static/media/ic-call.c240198bbfea9916a23a1d839cd0e823.svg";
export { ForwardRef as ReactComponent };